import { FinancialStatementAccount } from '../../models/common/FinancialStatementAccount';
import { UtilityTexts } from '../common/utilityClasses';

export class TrialBalanceTotals {
  totalBeforeChanges = 0;
  totalAdjustments = 0;
  totalAfterChanges = 0;
}

export interface ThinkTwiceModalController {
  isShown: boolean;
  text: UtilityTexts;
}

/**
 *
 * @param balance
 * @returns true if balance !== 0
 */
export const checkForZeroBalance = (balance: number) => (Boolean)(balance);

export const checkCountOfFilteredAccountsWithZeroBalance = (accounts: FinancialStatementAccount[]) =>
  accounts.filter((acc) => acc.showInTb === false).length;

export const getCountOfAllFilteredOutAccountsWithZeroBalance =
  (tbData: FinancialStatementAccount[], manualAccounts: FinancialStatementAccount[]) =>
    checkCountOfFilteredAccountsWithZeroBalance(tbData) + checkCountOfFilteredAccountsWithZeroBalance(manualAccounts);

